import { Component, effect, HostListener, OnInit, Input, Output, EventEmitter, inject, DestroyRef } from '@angular/core';
import { CommonModule, NgClass, NgFor, NgIf } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AppStateService } from 'src/app/shared/services/helpers/app-state.service';
import { RelationshipService } from 'src/app/shared/services/relationship/relationship.service';
import { Router } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import * as _ from 'lodash';
import { v4 as uuidv4 } from 'uuid';

interface journeyObject {
  id: string;
  name: string;
  description?: string;
  fields: any[];
  field_values: any[];
  isOpen: boolean;
  error?: any;
}

@Component({
  selector: 'app-create-journey',
  standalone: true,
  templateUrl: './create-journey.component.html',
  styleUrls: ['./create-journey.component.scss'],
  imports: [NgFor, NgIf, NgClass, FormsModule, CommonModule]
})
export class CreateJourneyComponent implements OnInit {
  dropdownData: any[] = [];
  @Input() isEditMode: boolean = false;
  @Output() closeModal = new EventEmitter<void>();
  journeyList: journeyObject[] = [];
  defaultStage: journeyObject = {
    id: '',
    name: '',
    description: '',
    fields: [],
    field_values: [],
    isOpen: false
  };
  accountId: any = null;
  selectedFieldMapping: any = {};
  journeyConfigList: any = [];
  destroyRef = inject(DestroyRef);
  userUniqueField: any = '';
  minimumNumberOfResponses: any = 2;
  isJourneyListValid: boolean = false;
  userUniqueFieldError: string | null = null;
  isUserUniqueFieldValid: boolean = false;
  minimumNumberOfResponsesError: string | null = null;
  isMinimumResponsesValid: boolean = true;
  userFieldList: any[] = [
    {
      field_id: 'tag_private_user_name',
      text: 'User Name'
    },

    {
      field_id: 'tag_private_email_address',
      text: 'Email Address'
    },
    {
      field_id: 'tag_private_phone_number',
      text: 'Phone Number'
    }
  ];

  defaultConfig: any = {}
  readOnlyMode :boolean = false;
  constructor(private _stateService: AppStateService, private _relationshipService: RelationshipService, private _router: Router) {
    effect(() => {
      if (this._stateService.initialized()) {
        if(Helpers?.adminRulesDic && !_.isEmpty(Helpers?.adminRulesDic) ){
          this.readOnlyMode = !_.get(Helpers?.adminRulesDic, 'ACCOUNT_MANAGE_RELATIONSHIP_CONFIG_UPDATE.write', false);
        }
        let accountDetails: any = this._stateService.accountDetails();
        let brandListDetails: any = this._stateService.brandListDetails();
        if (_.isEmpty(brandListDetails) && !_.isEmpty(Helpers?.brandListDetail)) {
          brandListDetails = Helpers.brandListDetail;
        }

        if (accountDetails && accountDetails._id) {
          this.accountId = accountDetails._id;
          if (accountDetails && _.hasIn(accountDetails, 'relationship_view.unique_fields_list') && !_.isEmpty(accountDetails.relationship_view.unique_fields_list)) {
            _.each(accountDetails.relationship_view.unique_fields_list, (uniqueField: any) => {
              if (uniqueField.field_id && !['tag_private_user_name', 'tag_private_email_address', 'tag_private_phone_number'].includes(uniqueField.field_id)) {
                this.userFieldList.push(uniqueField);
              }else{
                const index = this.userFieldList.findIndex((field: any) => field.field_id == uniqueField.field_id);
                if(index != -1){
                  this.userFieldList[index] = uniqueField;
                }
              }
            });
          }
          if (accountDetails && brandListDetails) {
            this.prepareDropdownData(accountDetails, brandListDetails);
          }
          let query: any = {
            account_id: accountDetails._id,
            is_active: true
          }
          this._relationshipService.getJourneyConfigByQuery(query).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((response: any) => {
            if (_.get(response, 'data.code') == 0 && _.has(response, 'data.journey_config.configs') && !_.isEmpty(response.data.journey_config.configs)) {
              this.defaultConfig = Helpers.deepClone(_.get(response, 'data.journey_config', {}))
              this.userUniqueField = _.get(response, 'data.journey_config.unique_field_id', '');
              this.minimumNumberOfResponses = _.get(response, 'data.journey_config.min_doc_count', 2);
              this.validateUserUniqueField();
              this.validateMinimumResponsesField();
              this.journeyList = this.prepareJourneyList(response.data.journey_config.configs);
              if (this.journeyList.length) {
                this.validateJourneyList()
              }

            } else {
              this.journeyList = [];
            }
          });
          // this is used to temporary store the journey config list
          this._relationshipService.getJourneyConfigList(accountDetails._id).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((response: any) => {
            if (_.get(response, 'data.code') == 0 && _.has(response, 'data.journey_configs') && !_.isEmpty(response.data.journey_configs)) {
              this.journeyConfigList = response.data.journey_configs;
            } else {
              this.journeyConfigList = [];
            }
          });
        }
      }

    })
  }

  ngOnInit(): void {

  }

  prepareJourneyList(journeyList: any) {
    let list: any = [];
    if (journeyList && journeyList.length) {
      list = _.map(journeyList, (journeyObject: any) => {
        journeyObject.description = journeyObject.description || '';
        journeyObject.id = journeyObject.id || uuidv4();
        journeyObject.name = journeyObject.name || '';
        journeyObject.field_values = _.map(journeyObject.fields, (field: any) => {
          return field.value;
        })
        return journeyObject
      });
    }
    return list;
  }

  prepareDropdownData(accountDetails: any, brandListDetails: any) {
    this.dropdownData = [];
    if (brandListDetails && !_.isEmpty(brandListDetails)) {
      brandListDetails.forEach((brand: any) => {
        if (brand?.is_single_touchpoint_setup == true && (brand?.main_rater_type == 3 || brand?.main_rater_type == 10) && (brand?.project_info?.project_status != 3)) {
          this.selectedFieldMapping[brand._id] = brand.name;
          this.dropdownData.push({
            value: brand._id,
            text: brand.name,
            type: "brand",
          });
        }

      });
    }
    // commented for now as we are not using tags in journey as of now
    // if(accountDetails && accountDetails.field_definitions && accountDetails.field_definitions.length){
    //   accountDetails.field_definitions.forEach((field:any) => {
    //     this.selectedFieldMapping[field.field_id] = field.name;
    //     this.dropdownData.push({
    //       id: field.field_id,
    //       name: field.name,
    //       type: "tag",
    //     });
    //   });
    // }
  }


  updateStageName(index: number, event: any) {
    this.journeyList[index].name = event.target.value;
    this.checkIfConfigExists(index);
    this.validateJourneyList()
    this.makeDirty()
  }
  updateStageDescription(index: number, event: any) {
    this.journeyList[index].description = event.target.value;
    this.checkIfConfigExists(index);
    this.validateJourneyList()
    this.makeDirty()
  }


  validateJourneyList() {
    let isJourneyListValid: boolean = true;
    _.each(this.journeyList, (journey: any) => {
      if (journey?.name == '' || !journey?.name || journey?.name?.length < 3) {
        isJourneyListValid = false;
      }
      if (journey?.fields?.length == 0 || !journey?.fields) {
        isJourneyListValid = false
      }
      if (journey?.error && !_.isEmpty(journey?.error)) {
        isJourneyListValid = false;
      }
    })
    this.isJourneyListValid = isJourneyListValid;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event) {
    // Check if click is outside of any dropdown
    const target = event.target as HTMLElement;
    if (!target.closest('.multi-select-dropdown')) {
      this.closeAllDropdowns();
    }
  }

  toggleDropdown(index: number) {
    // Close all other dropdowns first
    if (this.journeyList[index].isOpen) {
      this.closeAllDropdowns();
    } else {
      this.closeAllDropdowns();
      // Toggle the clicked dropdown
      this.journeyList[index].isOpen = true;
    }
  }

  closeAllDropdowns() {
    this.journeyList.forEach(stage => {
      stage.isOpen = false;
    });
  }

  selectField(journeyIndex: number, field: any) {
    const journeyObject: any = this.journeyList[journeyIndex];
    if (journeyObject?.field_values?.includes(field.value)) {
      journeyObject.field_values = journeyObject.field_values.filter(p => p !== field.value);
      journeyObject.fields = journeyObject.fields.filter(f => f.value !== field.value);
    } else {
      journeyObject.field_values.push(field.value);
      let fieldObject: any = {
        value: field.value,
        type: field.type
      }
      if (field.type == "brand") {
        fieldObject.field_id = "brand_id";
      } else {
        fieldObject.field_id = field?.field_id;
      }
      journeyObject.fields.push(fieldObject);
    }
    this.checkIfConfigExists(journeyIndex);

    this.validateJourneyList();
    this.makeDirty();
  }


  checkIfConfigExists(journeyIndex: number) {
    const journeyObject: any = this.journeyList[journeyIndex];
    let isFieldsExists = false;
    let isNameExists = false;
    _.each(this.journeyList, (journeyConfig: any, index: number) => {
      if (index !== journeyIndex) {
        if (journeyConfig?.name?.toLowerCase() == journeyObject?.name?.toLowerCase()) {
          isNameExists = true;
        }

        if (journeyObject.field_values.length == journeyConfig.field_values.length) {
          let matchCount = 0;
          _.each(journeyObject.field_values, (field: any) => {
            if (journeyConfig.field_values.includes(field)) {
              matchCount++;
            }
          })
          if (matchCount == journeyObject.field_values.length) {
            isFieldsExists = true;
          }
        }

      }
    })

    if (isFieldsExists || isNameExists) {
      this.journeyList[journeyIndex].error = {}
      if (isFieldsExists) {
        this.journeyList[journeyIndex].error['fields_error'] = true;
      }
      if (isNameExists) {
        this.journeyList[journeyIndex].error['name_error'] = true;
      }
    } else {
      delete this.journeyList[journeyIndex].error;
    }
  }

  addCustomProject(journeyIndex: number, event: any) {
    const projectName = event.target.value.trim();
    const journeyObject: any = this.journeyList[journeyIndex];
    if (projectName && !journeyObject?.field_values?.includes(projectName)) {
      journeyObject.field_values.push(projectName);
      if (!this.dropdownData.includes(projectName)) {
        this.dropdownData.push({
          id: projectName,
          name: projectName,
          type: "custom",
        });
      }
      this.journeyList[journeyIndex] = journeyObject;
    }
    event.target.value = '';
  }

  removeProject(journeyIndex: number, projectIndex: number, event: Event) {
    event.stopPropagation();
    const journeyObject: any = this.journeyList[journeyIndex];
    if (journeyObject?.field_values?.length) {
      journeyObject.field_values.splice(projectIndex, 1);
      journeyObject.fields.splice(projectIndex, 1);
    }
    this.journeyList[journeyIndex] = journeyObject;
    this.checkIfConfigExists(journeyIndex);
    this.validateJourneyList();
    this.makeDirty();
  }

  addJourneyStage() {
    if (this.journeyList.length < 10) {
      const newStage: journeyObject = {
        id: uuidv4(),
        name: '',
        description: '',
        field_values: [],
        fields: [],
        isOpen: false
      };
      this.journeyList.push(newStage);
      if (this.journeyList.length == 10) {
        Helpers.smallAlertBox("Warning", "You’ve reached your journey limit (10)", "WARN", 5000);
      }
      this.validateJourneyList();
      this.makeDirty();
    }

  }
  confirmDeleteJourney(index: number) {
    // this.deleteStage(index);
    if (this.journeyList[index].name == '' || this.journeyList[index].field_values.length == 0) {
      this.deleteStage(index);
    } else {
      var errorMsg = `Are you sure you want to delete the journey "${this.journeyList[index].name}"?`;
      var title = "Delete Journey";
      var buttons = [{
        text: "Cancel",
        type: 'secondary',
        key: 'cancel'
      }, {
        text: "Yes, Delete",
        type: 'danger',
        key: 'Yes'
      }];


      Helpers.SmartMessageBox({
        title: title,
        content: errorMsg,
        buttons: buttons
      }, (ButtonPressed) => {
        setTimeout(() => {
          if (ButtonPressed === "Yes") {
            this.deleteStage(index);
          }
        }, 50);
      });
    }
  }

  deleteStage(index: number) {
    if (this.journeyList.length == 1) {
      this.journeyList.splice(index, 1);
      const newStage: journeyObject = {
        id: uuidv4(),
        name: '',
        description: '',
        field_values: [],
        fields: [],
        isOpen: false
      };
      this.journeyList.push(newStage);
    } else {
      this.journeyList.splice(index, 1);
    }
    this.validateJourneyList()
    this.makeDirty()
  }

  proceedToJourney() {
    this.validateUserUniqueField();
    this.validateMinimumResponsesField();
    if (!this.isUserUniqueFieldValid || !this.isMinimumResponsesValid) {
      return;
    }
    let configs = _.map(this.journeyList, (journeyObject: any) => {
      return {
        id: journeyObject.id,
        name: journeyObject.name,
        description: journeyObject.description,
        fields: journeyObject.fields
      }
    })
    let uniqueFieldType: any = null
    _.each(this.userFieldList, (field: any) => {
      if (this.userUniqueField == field.field_id && field.type && field.type != null && field.type != undefined && field.type != '') {
        uniqueFieldType = field.type
      }
    })
    if (!uniqueFieldType) {
      uniqueFieldType = (this.userUniqueField.includes('tag_private')) ? 'tag' : null
    }
    let journeyConfig: any = {
      configs: configs,
      unique_field_id: this.userUniqueField,
      unique_field_type: uniqueFieldType,
      min_doc_count: this.minimumNumberOfResponses,
      account_id: this.accountId
    }
    this.removeJourneyConfig().then((res: any) => {
      this._relationshipService.saveJourneyConfig(this.accountId, journeyConfig).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((res: any) => {
        if (res) {
          if (this.isEditMode) {
            this.closeModal.emit();
          } else {
            // this._router.navigate(['/accounts/relationship-view/journey']);
          }
          this._relationshipService.updateConfig(journeyConfig);
        }
      });
    });
  }

  removeJourneyConfig() {
    return new Promise((resolve) => {
      if (this.journeyConfigList.length >= 10) {
        this.journeyConfigList = _.sortBy(this.journeyConfigList, (journeyConfig: any) => {
          const parts = journeyConfig?.version?.split('.').map(Number);
          return parts[2];
        });
        let version = this.journeyConfigList[0].version;
        this._relationshipService.removeJourneyConfig(this.accountId, version).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((res: any) => {
          resolve(true);
        });
      } else {
        resolve(true);
      }
    });
  }

  isDirty: boolean = false;

  makeDirty() {
    this.isDirty = false;
    if (this.userUniqueField !== this.defaultConfig.unique_field_id) {
      this.isDirty = true
    }

    if (this.minimumNumberOfResponses !== this.defaultConfig.min_doc_count) {
      this.isDirty = true
    }
    if (this.generateHash(this.journeyList) !== this.generateHash(this.defaultConfig.configs)) {
      this.isDirty = true
    }
  }

  private generateHash(obj): string {
    const fields = ['name', 'description', 'fields'];
    if (obj !== undefined && !_.isEmpty(obj)) {
      return _.map(obj, (obj) => {
        let objString = '';
        _.each(fields, (field) => {
          objString += `${obj[field]}-`;
        });
        return objString;
      }).join('|'); // Simple hash function
    } else {
      return 'NOHASHED'
    }
  }

  closeQuestionModal() {
    this.closeModal.emit();
  }

  validateNumber(event: any): boolean {
    // Allow only digits (0-9); allow control keys (charCode 0 = backspace, etc.)
    if (event.charCode !== undefined && event.charCode !== 0 && (event.charCode < 48 || event.charCode > 57)) {
      event.preventDefault();
      return false;
    }
    return true;
  }

  validateUserUniqueField(): void {
    const val = this.userUniqueField;
    if (val === '' || val === null || val === undefined) {
      this.userUniqueFieldError = 'Field cannot be empty';
      this.isUserUniqueFieldValid = false;
    } else {
      this.userUniqueFieldError = null;
      this.isUserUniqueFieldValid = true;
    }
    this.makeDirty();
  }

  validateMinimumResponsesField(): void {
    const val = this.minimumNumberOfResponses;
    if (val === '' || val === null || val === undefined) {
      this.minimumNumberOfResponsesError = 'Field cannot be empty';
      this.isMinimumResponsesValid = false;
      return;
    }
    const num = Number(val);
    if (isNaN(num) || num < 2) {
      this.minimumNumberOfResponses = 2;
      this.minimumNumberOfResponsesError = null;
      this.isMinimumResponsesValid = true;
    } else {
      this.minimumNumberOfResponsesError = null;
      this.isMinimumResponsesValid = true;
    }
    this.makeDirty();
  }
}
